import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormSectionSkeleton, Skeleton, SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

import {AssignGuid} from './assign-guid/assign-guid';
import {GenerateLoginLink} from './generate-login-link';
import {ResetUserMfa} from './reset-user-mfa';
import {SendLoginEmail} from './send-login-email';
import {SendResetPasswordEmail} from './send-reset-password';
import {UnlockUser} from './unlock-user';

type Props = {
    userId: number,
    disabled: boolean,
    isSsoMandatory: boolean,
    isLoading: boolean,
};

export const LoginActions = ({disabled, userId, isLoading, isSsoMandatory}: Props) => (
    <Skeleton
        shown={isLoading}
        view={(
            <FormSectionSkeleton labelWidth={132}>
                <Group>
                    <SkeletonItem width={162} height={32}/>
                    <SkeletonItem width={162} height={32}/>
                    <SkeletonItem width={182} height={32}/>
                    <SkeletonItem width={162} height={32}/>
                    <SkeletonItem width={157} height={32}/>
                    <SkeletonItem width={157} height={32}/>
                </Group>
            </FormSectionSkeleton>
        )}>
        <FormSection headline="Login Actions">
            <ResponsiveElementGroup>
                <SendResetPasswordEmail
                    userId={userId}
                    disabled={disabled || isSsoMandatory}
                />
                <SendLoginEmail
                    userId={userId}
                    disabled={disabled || isSsoMandatory}
                />
                <GenerateLoginLink
                    userId={userId}
                    disabled={disabled || isSsoMandatory}
                />
                <UnlockUser userId={userId}/>
                <ResetUserMfa userId={userId} disabled={disabled}/>
                <AssignGuid userId={userId}/>
            </ResponsiveElementGroup>
        </FormSection>
    </Skeleton>
);
